export const staticTemplates = {
  groupedTemplates: {
    Religious: [
      {
        id: "43c3b800-2402-11f0-a65e-6d63fa426460",
        publicEvent: false,
        createdAt: {
          _seconds: 1745825259,
          _nanoseconds: 392000000,
        },
        eventId: "43c3b800-2402-11f0-a65e-6d63fa426460",
        isTemplate: true,
        eventStatus: "open",
        description:
          "Celebrate the birth of Lord Krishna with a grand Janmashtami extravaganza! Enjoy devotional songs, mesmerizing dance performances, interactive storytelling, and delicious prasadam. Immerse yourself in the joyous festivities of this auspicious day.",
        initiatorName: "System",
        category: "Religious",
        title: "Krishna Janmashtami Extravaganza",
        flyerImage:
          "https://images.unsplash.com/photo-1504609813442-a8924e83f76e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwxfHxLcmlzaG5hJTIwSmFubWFzaHRhbWklMjBFeHRyYXZhZ2FuemElMjBLcmlzaG5hJTIwSmFubWFzaHRhbWklMkMlMjBMb3JkJTIwS3Jpc2huYSUyQyUyMGRldm90aW9uYWwlMkMlMjBkYW5jZSUyQyUyMHN0b3J5dGVsbGluZyUyQyUyMHByYXNhZGFtJTIwSGluZHV8ZW58MHx8fHwxNzQ1ODI1MjU5fDA&ixlib=rb-4.0.3&q=80&w=400",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        totalMember: null,
        tags: [
          "Krishna Janmashtami",
          "Lord Krishna",
          "devotional",
          "dance",
          "storytelling",
          "prasadam",
          "letshang-templates",
          "Hindu",
        ],
      },
      {
        id: "6b1640e0-2fd7-11f0-95b3-d9b74f3f60fb",
        publicEvent: false,
        createdAt: {
          _seconds: 1747126270,
          _nanoseconds: 958000000,
        },
        eventId: "6b1640e0-2fd7-11f0-95b3-d9b74f3f60fb",
        isTemplate: true,
        eventStatus: "open",
        description:
          "Join us in lighting lanterns to commemorate the birth, enlightenment, and passing of Buddha. Experience the beauty and serenity of Vesak.",
        initiatorName: "System",
        category: "Religious",
        title: "Vesak Lantern Parade",
        flyerImage:
          "https://images.unsplash.com/photo-1593900107410-470abc92a26e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwxfHxWZXNhayUyMExhbnRlcm4lMjBQYXJhZGUlMjBWZXNhayUyQyUyMEJ1ZGRoaXNtJTJDJTIwTGFudGVybiUyMFBhcmFkZSUyQyUyMFBlYWNlZnVsJTIwQnVkZGhpc3R8ZW58MHx8fHwxNzQ3MTI2MjcwfDA&ixlib=rb-4.1.0&q=80&w=400",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        tags: [
          "Vesak",
          "Buddhism",
          "Lantern Parade",
          "Peaceful",
          "letshang-templates",
          "Buddhist",
        ],
      },
      {
        id: "6b311be0-2fd7-11f0-95b3-d9b74f3f60fb",
        publicEvent: false,
        createdAt: {
          _seconds: 1747126271,
          _nanoseconds: 134000000,
        },
        eventId: "6b311be0-2fd7-11f0-95b3-d9b74f3f60fb",
        isTemplate: true,
        eventStatus: "open",
        description:
          "Join us for a festive celebration of the resurrection of Jesus Christ! Enjoy music, food, and fun activities for the whole family.",
        initiatorName: "System",
        category: "Religious",
        title: "Easter Extravaganza",
        flyerImage:
          "https://images.unsplash.com/photo-1457301473530-d6d4d4d7b824?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwxfHxFYXN0ZXIlMjBTdW5yaXNlJTIwU2VydmljZSUyMEVhc3RlciUyQyUyMENocmlzdGlhbml0eSUyQyUyMHN1bnJpc2UlMkMlMjBzZXJ2aWNlJTJDJTIwcmVzdXJyZWN0aW9uJTIwQ2hyaXN0aWFufGVufDB8fHx8MTc0NzEyNjQxNHww&ixlib=rb-4.1.0&q=80&w=400",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        tags: [
          "Easter",
          "Christianity",
          "Family-friendly",
          "Celebration",
          "letshang-templates",
          "Christian",
        ],
      },
      {
        id: "6b3e6250-2fd7-11f0-95b3-d9b74f3f60fb",
        publicEvent: false,
        createdAt: {
          _seconds: 1747126271,
          _nanoseconds: 221000000,
        },
        eventId: "6b3e6250-2fd7-11f0-95b3-d9b74f3f60fb",
        isTemplate: true,
        eventStatus: "open",
        description:
          "Come together for a communal meal to break the fast during the holy month of Ramadan. Enjoy delicious food, spiritual reflections, and community bonding.",
        initiatorName: "System",
        category: "Religious",
        title: "Ramadan Iftar Gathering",
        flyerImage:
          "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwxfHxSYW1hZGFuJTIwSWZ0YXIlMjBHYXRoZXJpbmclMjBSYW1hZGFuJTJDJTIwSXNsYW0lMkMlMjBJZnRhciUyQyUyMENvbW11bml0eSUyMEV2ZW50JTIwSXNsYW1pY3xlbnwwfHx8fDE3NDcxMjYyNzB8MA&ixlib=rb-4.1.0&q=80&w=400",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        tags: [
          "Ramadan",
          "Islam",
          "Iftar",
          "Community Event",
          "letshang-templates",
          "Islamic",
        ],
      },
      {
        id: "6b5e1f50-2fd7-11f0-95b3-d9b74f3f60fb",
        publicEvent: false,
        createdAt: {
          _seconds: 1747126271,
          _nanoseconds: 429000000,
        },
        eventId: "6b5e1f50-2fd7-11f0-95b3-d9b74f3f60fb",
        isTemplate: true,
        eventStatus: "open",
        description:
          "Celebrate the miracle of Hanukkah with candle lighting, traditional songs, delicious latkes, and dreidel games. Fun for all ages!",
        initiatorName: "System",
        category: "Religious",
        title: "Hanukkah Festival of Lights",
        flyerImage:
          "https://images.unsplash.com/photo-1608044838338-dd458d127926?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHw2fHxIYW51a2thaHxlbnwwfHx8fDE3NDc2NDY2MjZ8MA&ixlib=rb-4.1.0&q=80&w=1080",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        tags: [
          "Hanukkah",
          "Judaism",
          "Festival",
          "Family-friendly",
          "letshang-templates",
          "Jewish",
        ],
      },
      {
        id: "c09a09c0-2fd7-11f0-95b3-d9b74f3f60fb",
        publicEvent: false,
        createdAt: {
          _seconds: 1747126414,
          _nanoseconds: 428000000,
        },
        eventId: "c09a09c0-2fd7-11f0-95b3-d9b74f3f60fb",
        isTemplate: true,
        eventStatus: "open",
        description:
          "Celebrate the end of Ramadan with a grand Eid al-Fitr feast. Enjoy delicious traditional dishes, music, and prayers as we come together in gratitude.",
        initiatorName: "System",
        category: "Religious",
        title: "Eid al-Fitr Feast",
        flyerImage:
          "https://images.unsplash.com/photo-1574246604907-db69e30ddb97?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwyfHxFaWR8ZW58MHx8fHwxNzQ3NjQ2NzAwfDA&ixlib=rb-4.1.0&q=80&w=400",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        tags: [
          "Eid al-Fitr",
          "Ramadan",
          "feast",
          "Muslim",
          "celebration",
          "letshang-templates",
        ],
      },
      {
        id: "c0a8d6d0-2fd7-11f0-95b3-d9b74f3f60fb",
        publicEvent: false,
        createdAt: {
          _seconds: 1747126414,
          _nanoseconds: 525000000,
        },
        eventId: "c0a8d6d0-2fd7-11f0-95b3-d9b74f3f60fb",
        isTemplate: true,
        eventStatus: "open",
        description:
          "Experience the rich traditions of Passover with a special Seder night. Join us for symbolic foods, prayers, and storytelling to commemorate freedom and faith.",
        initiatorName: "System",
        category: "Religious",
        title: "Passover Seder Night",
        flyerImage:
          "https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwxfHxQYXNzb3ZlciUyMFNlZGVyJTIwTmlnaHQlMjBQYXNzb3ZlciUyQyUyMFNlZGVyJTJDJTIwSnVkYWlzbSUyQyUyMHRyYWRpdGlvbnMlMkMlMjBmcmVlZG9tJTIwSmV3aXNofGVufDB8fHx8MTc0NzEyNjQxNHww&ixlib=rb-4.1.0&q=80&w=400",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        tags: [
          "Passover",
          "Seder",
          "Judaism",
          "traditions",
          "freedom",
          "letshang-templates",
          "Jewish",
        ],
      },
    ],
    Sporting: [
      {
        id: "822717e0-2402-11f0-a65e-6d63fa426460",
        publicEvent: false,
        createdAt: {
          _seconds: 1745825364,
          _nanoseconds: 62000000,
        },
        eventId: "822717e0-2402-11f0-a65e-6d63fa426460",
        isTemplate: true,
        eventStatus: "open",
        description:
          "Join us for an adrenaline-pumping sprint challenge where participants will race against the clock to reach the finish line. Test your speed and agility in this exciting event!",
        initiatorName: "System",
        category: "Sporting",
        title: "Speedy Sprint Challenge",
        flyerImage:
          "https://images.unsplash.com/photo-1452626038306-9aae5e071dd3?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwxfHxTcGVlZHklMjBTcHJpbnQlMjBDaGFsbGVuZ2UlMjBydW5uaW5nJTJDJTIwc3ByaW50JTJDJTIwY2hhbGxlbmdlJTJDJTIwc3BlZWQlMkMlMjBhZ2lsaXR5JTIwUnVubmluZ3xlbnwwfHx8fDE3NDU4MjUzNjR8MA&ixlib=rb-4.0.3&q=80&w=400",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        tags: [
          "running",
          "sprint",
          "challenge",
          "speed",
          "agility",
          "letshang-templates",
        ],
        totalMember: null,
      },
      {
        id: "cf3a20e0-2fd8-11f0-95b3-d9b74f3f60fb",
        publicEvent: false,
        createdAt: {
          _seconds: 1747126868,
          _nanoseconds: 462000000,
        },
        eventId: "cf3a20e0-2fd8-11f0-95b3-d9b74f3f60fb",
        isTemplate: true,
        eventStatus: "open",
        description:
          "Calling all pickleball enthusiasts! Compete in our exciting tournament and enjoy a day filled with fun, competition, and camaraderie. Don't miss out on the action!",
        initiatorName: "System",
        category: "Sporting",
        title: "Pickleball Palooza",
        flyerImage:
          "https://images.unsplash.com/photo-1524190953017-a0e58d1db9ef?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwzfHxwaWNrbGViYWxsfGVufDB8fHx8MTc0NzY1MTI2Nnww&ixlib=rb-4.1.0&q=80&w=1080",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        tags: [
          "Pickleball",
          "Tournament",
          "Sports",
          "Competition",
          "letshang-templates",
          "Pickleball Tournament",
        ],
      },
      {
        id: "cf3c6ad0-2fd8-11f0-95b3-d9b74f3f60fb",
        publicEvent: false,
        createdAt: {
          _seconds: 1747126868,
          _nanoseconds: 477000000,
        },
        eventId: "cf3c6ad0-2fd8-11f0-95b3-d9b74f3f60fb",
        isTemplate: true,
        eventStatus: "open",
        description:
          "Join us for an action-packed soccer tournament where teams battle it out to be crowned champions. Bring your A-game and showcase your skills on the field!",
        initiatorName: "System",
        category: "Sporting",
        title: "Goal Rush Soccer Showdown",
        flyerImage:
          "https://images.unsplash.com/photo-1517747614396-d21a78b850e8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwzfHxTb2NjZXIlMjBTaG93ZG93bnxlbnwwfHx8fDE3NDc2NDk5ODN8MA&ixlib=rb-4.1.0&q=80&w=400",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        tags: [
          "Soccer",
          "Tournament",
          "Sports",
          "Competition",
          "letshang-templates",
          "Soccer Tournament",
        ],
      },
      {
        id: "cf52d900-2fd8-11f0-95b3-d9b74f3f60fb",
        publicEvent: false,
        createdAt: {
          _seconds: 1747126868,
          _nanoseconds: 624000000,
        },
        eventId: "cf52d900-2fd8-11f0-95b3-d9b74f3f60fb",
        isTemplate: true,
        eventStatus: "open",
        description:
          "Gear up for an adrenaline-pumping paintball experience like no other. Navigate the battlefield, strategize with your team, and emerge victorious in this thrilling event!",
        initiatorName: "System",
        category: "Sporting",
        title: "Paintball Pandemonium",
        flyerImage:
          "https://images.unsplash.com/photo-1588432815128-363254491e4e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwzfHxwYWludGJhbGx8ZW58MHx8fHwxNzQ3NjUxMzY4fDA&ixlib=rb-4.1.0&q=80&w=1080",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        tags: [
          "Paintball",
          "Adventure",
          "Sports",
          "Competition",
          "letshang-templates",
          "Paint ball",
        ],
      },
      {
        id: "150e01a0-318b-11f0-9f91-e30cfce0ae3e",
        publicEvent: false,
        eventId: "150e01a0-318b-11f0-9f91-e30cfce0ae3e",
        description:
          "Join us for an epic Battle Royale Tournament in Fortnite! Compete against other players in a fight for survival and victory. Prizes for the top performers!",
        initiatorName: "System",
        createdAt: {
          _seconds: 1747313387,
          _nanoseconds: 194000000,
        },
        unsplashKeyword: "Battle Royale Tournament Fortnite gaming",
        isTemplate: true,
        eventStatus: "open",
        category: "Sporting",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        flyerImage:
          "https://images.unsplash.com/photo-1589241062272-c0a000072dfa?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwxfHxmb3J0bml0ZXxlbnwwfHx8fDE3NDczMTM0Mjd8MA&ixlib=rb-4.1.0&q=80&w=1080",
        title: "Fortnite Tournament",
        tags: [
          "Fortnite",
          "gaming",
          "tournament",
          "Battle Royale",
          "letshang-templates",
          "Online games",
        ],
      },
      {
        id: "76ff9c50-3160-11f0-aed4-81351f008bfb",
        publicEvent: false,
        eventId: "76ff9c50-3160-11f0-aed4-81351f008bfb",
        description:
          "Tee off on a challenging course and showcase your golfing prowess in the prestigious Fairway Classic Tournament!",
        initiatorName: "System",
        title: "Fairway Classic Tournament",
        tags: [
          "golf",
          "tournament",
          "course",
          "putting",
          "letshang-templates",
          "Golf",
        ],
        createdAt: {
          _seconds: 1747295083,
          _nanoseconds: 157000000,
        },
        unsplashKeyword: "Fairway Classic Tournament golf",
        isTemplate: true,
        eventStatus: "open",
        category: "Sporting",
        flyerImage:
          "https://images.unsplash.com/photo-1473174038344-40656aad79bf?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwxfHxGYWlyd2F5JTIwQ2xhc3NpYyUyMFRvdXJuYW1lbnQlMjBnb2xmfGVufDB8fHx8MTc0NzI5NTA4MHww&ixlib=rb-4.1.0&q=80&w=1080",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
      },
      {
        id: "12dfe190-318c-11f0-9f91-e30cfce0ae3e",
        publicEvent: false,
        eventId: "12dfe190-318c-11f0-9f91-e30cfce0ae3e",
        description:
          "Experience the thrill of sharpshooters battling it out in a three-point shooting contest. Watch as players take aim from beyond the arc and compete for the title of the best long-range shooter!",
        initiatorName: "System",
        title: "Three-Point Shootout Extravaganza",
        tags: [
          "basketball",
          "three-point shootout",
          "contest",
          "shooters",
          "letshang-templates",
          "Basketball",
        ],
        createdAt: {
          _seconds: 1747313813,
          _nanoseconds: 33000000,
        },
        unsplashKeyword:
          "Three-Point Shootout Extravaganza basketball contest shooters",
        isTemplate: true,
        eventStatus: "open",
        category: "Sporting",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        flyerImage:
          "https://images.unsplash.com/photo-1574623452334-1e0ac2b3ccb4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwzfHxiYXNrZXRiYWxsfGVufDB8fHx8MTc0NzY1MjMxOXww&ixlib=rb-4.1.0&q=80&w=1080",
      },
      {
        id: "76f16b80-3160-11f0-aed4-81351f008bfb",
        publicEvent: false,
        eventId: "76f16b80-3160-11f0-aed4-81351f008bfb",
        description:
          "Engage in fast-paced rallies and showcase your shot-making skills in the exciting Rally Master Challenge event!",
        initiatorName: "System",
        title: "Rally Master Challenge",
        tags: [
          "tennis",
          "rally",
          "challenge",
          "skills",
          "letshang-templates",
          "Tennis",
        ],
        createdAt: {
          _seconds: 1747295083,
          _nanoseconds: 64000000,
        },
        unsplashKeyword: "Rally Master Challenge tennis",
        isTemplate: true,
        eventStatus: "open",
        category: "Sporting",
        flyerImage:
          "https://images.unsplash.com/photo-1526888935184-a82d2a4b7e67?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwxfHxSYWxseSUyME1hc3RlciUyMENoYWxsZW5nZSUyMHRlbm5pc3xlbnwwfHx8fDE3NDcyOTUwODB8MA&ixlib=rb-4.1.0&q=80&w=1080",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
      },
    ],
    Underground: [
      {
        id: "5d50a3c0-3161-11f0-a903-c5f01bd085db",
        publicEvent: false,
        eventId: "5d50a3c0-3161-11f0-a903-c5f01bd085db",
        description:
          "Enter the Techno Tunnel where underground DJs will take you on a journey through pulsating techno beats. Get lost in the music!",
        initiatorName: "System",
        title: "Techno Tunnel",
        tags: [
          "techno",
          "DJ sets",
          "journey",
          "beats",
          "music",
          "letshang-templates",
          "DJ Sets",
        ],
        createdAt: {
          _seconds: 1747295469,
          _nanoseconds: 563000000,
        },
        unsplashKeyword: "Techno Tunnel techno DJ sets beats",
        isTemplate: true,
        eventStatus: "open",
        category: "Underground",
        flyerImage:
          "https://images.unsplash.com/photo-1495870043034-74e1a009f631?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwxfHxUZWNobm8lMjBUdW5uZWwlMjB0ZWNobm8lMjBESiUyMHNldHMlMjBiZWF0c3xlbnwwfHx8fDE3NDcyOTU0Njl8MA&ixlib=rb-4.1.0&q=80&w=1080",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
      },
      {
        id: "4a628f70-3185-11f0-9f91-e30cfce0ae3e",
        publicEvent: false,
        eventId: "4a628f70-3185-11f0-9f91-e30cfce0ae3e",
        description:
          "Join us for an exclusive evening of intimate live music performances in a hidden underground location. Discover your new favorite artists in a one-of-a-kind setting.",
        initiatorName: "System",
        title: "Secret Stage Sessions",
        tags: [
          "secret stage",
          "intimate",
          "live music",
          "underground",
          "exclusive",
          "letshang-templates",
          "Live Music events",
        ],
        createdAt: {
          _seconds: 1747310899,
          _nanoseconds: 687000000,
        },
        unsplashKeyword: "Secret Stage Sessions live music underground",
        isTemplate: true,
        eventStatus: "open",
        category: "Underground",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        flyerImage:
          "https://images.unsplash.com/photo-1603190287605-e6ade32fa852?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHw0fHxsaXZlJTIwbXVzaWN8ZW58MHx8fHwxNzQ3MzExMjAxfDA&ixlib=rb-4.1.0&q=80&w=1080",
      },
      {
        id: "5e9ecea0-3161-11f0-a903-c5f01bd085db",
        publicEvent: false,
        eventId: "5e9ecea0-3161-11f0-a903-c5f01bd085db",
        description:
          "Whispering Whiskey is the secret underground party that everyone's talking about. Join us for a night of hidden delights and forbidden fun!",
        initiatorName: "System",
        title: "Whispering Whiskey",
        tags: [
          "whiskey",
          "secret party",
          "hidden",
          "delights",
          "fun",
          "letshang-templates",
          "Secret parties",
        ],
        createdAt: {
          _seconds: 1747295471,
          _nanoseconds: 673000000,
        },
        unsplashKeyword: "Whispering Whiskey whiskey secret party hidden",
        isTemplate: true,
        eventStatus: "open",
        category: "Underground",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        flyerImage:
          "https://images.unsplash.com/photo-1529264978834-666a0e99f884?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHw0fHxXaGlzcGVyaW5nJTIwV2hpc2tleXxlbnwwfHx8fDE3NDcyOTc1OTN8MA&ixlib=rb-4.1.0&q=80&w=1080",
      },
      {
        id: "5e9f6ae0-3161-11f0-a903-c5f01bd085db",
        publicEvent: false,
        eventId: "5e9f6ae0-3161-11f0-a903-c5f01bd085db",
        description:
          "Keep the party going at our exclusive underground afterparty. Dance, drink, and mingle with fellow night owls until the sun comes up!",
        initiatorName: "System",
        title: "Late Night Revelry",
        tags: [
          "late night",
          "afterparty",
          "dance",
          "drink",
          "night owls",
          "letshang-templates",
          "Afterparties",
        ],
        createdAt: {
          _seconds: 1747295471,
          _nanoseconds: 758000000,
        },
        unsplashKeyword: "Late Night Revelry late night afterparty dance",
        isTemplate: true,
        eventStatus: "open",
        category: "Underground",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        flyerImage:
          "https://images.unsplash.com/photo-1568973290903-850cb66e92c9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwxfHxsYXRlJTIwbmlnaHQlMjBwYXJ0eXxlbnwwfHx8fDE3NDczMTA2Mjl8MA&ixlib=rb-4.1.0&q=80&w=1080",
      },
      {
        id: "5eafe5a0-3161-11f0-a903-c5f01bd085db",
        publicEvent: false,
        eventId: "5eafe5a0-3161-11f0-a903-c5f01bd085db",
        description:
          "Experience a futuristic underground event filled with neon lights, interactive art installations, and immersive experiences. A night of sensory overload!",
        initiatorName: "System",
        title: "Neon Nights",
        tags: [
          "neon lights",
          "immersive",
          "art installations",
          "futuristic",
          "sensory",
          "letshang-templates",
          "Others",
        ],
        createdAt: {
          _seconds: 1747295471,
          _nanoseconds: 866000000,
        },
        unsplashKeyword: "Neon Nights neon lights immersive futuristic",
        isTemplate: true,
        eventStatus: "open",
        category: "Underground",
        flyerImage:
          "https://images.unsplash.com/photo-1556820524-9aca1796459e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwxfHxOZW9uJTIwTmlnaHRzJTIwbmVvbiUyMGxpZ2h0cyUyMGltbWVyc2l2ZSUyMGZ1dHVyaXN0aWN8ZW58MHx8fHwxNzQ3Mjk1NDY5fDA&ixlib=rb-4.1.0&q=80&w=1080",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
      },
    ],
    Organizers: [
      {
        id: "9f5dd1c0-3161-11f0-a903-c5f01bd085db",
        publicEvent: false,
        eventId: "9f5dd1c0-3161-11f0-a903-c5f01bd085db",
        description:
          "Celebrate your academic achievements with a memorable graduation party filled with joy, laughter, and fun activities.",
        initiatorName: "System",
        title: "Diploma Delight Celebration",
        tags: [
          "graduation",
          "party",
          "academic",
          "celebration",
          "letshang-templates",
          "Graduation parties",
        ],
        createdAt: {
          _seconds: 1747295580,
          _nanoseconds: 380000000,
        },
        unsplashKeyword:
          "Diploma Delight Celebration graduation party academic celebration",
        isTemplate: true,
        eventStatus: "open",
        category: "Organizers",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        flyerImage:
          "https://images.unsplash.com/photo-1593985818125-f506da53a292?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwyOHx8R3JhZHVhdGlvbiUyMHBhcnRpZXN8ZW58MHx8fHwxNzQ3Mjk2NzM3fDA&ixlib=rb-4.1.0&q=80&w=1080",
      },
      {
        id: "5ff593f0-3180-11f0-9f91-e30cfce0ae3e",
        publicEvent: false,
        eventId: "5ff593f0-3180-11f0-9f91-e30cfce0ae3e",
        description:
          "Join us for a fun-filled baby shower celebration to honor the mom-to-be and equip her with all the essentials for diaper duty. Let's shower her with love and gifts!",
        initiatorName: "System",
        title: "Diaper Duty Delight",
        tags: [
          "baby shower",
          "diaper duty",
          "celebration",
          "gifts",
          "mom-to-be",
          "letshang-templates",
          "Baby Shower",
        ],
        createdAt: {
          _seconds: 1747308788,
          _nanoseconds: 399000000,
        },
        unsplashKeyword: "Diaper Duty Delight baby shower",
        isTemplate: true,
        eventStatus: "open",
        category: "Organizers",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        flyerImage:
          "https://images.unsplash.com/photo-1658949556725-577c071e92df?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwxNnx8ZGlhcGVyJTIwYmFieXxlbnwwfHx8fDE3NDczMDg5MzF8MA&ixlib=rb-4.1.0&q=80&w=400",
      },
      {
        id: "9f64d6a0-3161-11f0-a903-c5f01bd085db",
        publicEvent: false,
        eventId: "9f64d6a0-3161-11f0-a903-c5f01bd085db",
        description:
          "Create a dazzling birthday celebration filled with sparkle, glitter, and fun activities to make the day truly special.",
        initiatorName: "System",
        title: "Spectacular Sparkle Spectacle",
        tags: [
          "birthday",
          "party",
          "celebration",
          "glitter",
          "letshang-templates",
          "Birthday",
        ],
        createdAt: {
          _seconds: 1747295580,
          _nanoseconds: 426000000,
        },
        unsplashKeyword:
          "Spectacular Sparkle Spectacle birthday party celebration glitter",
        isTemplate: true,
        eventStatus: "open",
        category: "Organizers",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        flyerImage:
          "https://images.unsplash.com/photo-1525268771113-32d9e9021a97?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwyMnx8QmlydGhkYXl8ZW58MHx8fHwxNzQ3Mjk2NDQ0fDA&ixlib=rb-4.1.0&q=80&w=1080",
      },
      {
        id: "78d76690-3181-11f0-9f91-e30cfce0ae3e",
        publicEvent: false,
        eventId: "78d76690-3181-11f0-9f91-e30cfce0ae3e",
        description:
          "Join us in bidding adieu to our dear friend with a fun-filled fiesta featuring music, games, and heartfelt goodbyes.",
        initiatorName: "System",
        title: "Fond Farewell Fiesta",
        createdAt: {
          _seconds: 1747309259,
          _nanoseconds: 641000000,
        },
        unsplashKeyword:
          "Fond Farewell Fiesta farewell fiesta friendship party",
        isTemplate: true,
        eventStatus: "open",
        category: "Organizers",
        initiatorUid: "aWCRRIv1OdXqsVldTdKXj29El9q1",
        tags: [
          "farewell",
          "fiesta",
          "friendship",
          "party",
          "letshang-templates",
          "Casual Hang",
        ],
        flyerImage:
          "https://images.unsplash.com/photo-1701566082955-080fc537dcf3?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDEzNzB8MHwxfHNlYXJjaHwzfHxmYXJld2VsbCUyMHBhcnR5fGVufDB8fHx8MTc0NzMwOTYzOHww&ixlib=rb-4.1.0&q=80&w=400",
      },
    ],
  },
}
